import { render, staticRenderFns } from "./DocumentCard.vue?vue&type=template&id=1adaa12e&scoped=true&"
import script from "./DocumentCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DocumentCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DocumentCard.vue?vue&type=style&index=0&id=1adaa12e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adaa12e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1adaa12e')) {
      api.createRecord('1adaa12e', component.options)
    } else {
      api.reload('1adaa12e', component.options)
    }
    module.hot.accept("./DocumentCard.vue?vue&type=template&id=1adaa12e&scoped=true&", function () {
      api.rerender('1adaa12e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/document/index/components/DocumentCard.vue"
export default component.exports